<template>
    <div class="contenedor-sitebar">
      <div>
        <div class="d-flex justify-end">
        <v-btn @click.prevent="Cerrar" class="mx-2" fab dark small color="primary">
            <v-icon dark>mdi-close</v-icon>
        </v-btn>
    </div>
    <v-list-item>
      <v-list-item-avatar color="grey">
        <v-icon dark>mdi-information-outline</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>Registro - {{selectTable.valor.fecha}} </v-list-item-title>
        <v-list-item-subtitle>
          {{selectTable.valor.location}}
        </v-list-item-subtitle>
        <v-list-item-subtitle v-if="selectTable.valor.syncronizacions_id == null">
          Creado localmente <v-icon>mdi-home</v-icon>
        </v-list-item-subtitle>
        <v-list-item-subtitle v-else>
          Desde nube <v-icon>mdi-cloud-download</v-icon>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-title>
      Fecha de creación del registro:
    </v-card-title>

    <v-card-subtitle>
      {{selectTable.valor.fecha_subida}}
    </v-card-subtitle>
     <div>
         <v-list-item>
         <v-list-item-content>
            <v-list-item-title>Equipo: {{selectTable.valor.vm}} - {{selectTable.valor.vp}} </v-list-item-title>
            
            <v-list-item-subtitle v-if="selectTable.valor.alerta" style="color:red">
               Conductor suplente: {{selectTable.valor.cn}} - {{selectTable.valor.ci}}
            </v-list-item-subtitle>

            <v-list-item-subtitle v-else>
               Asignado: {{selectTable.valor.cn}} - {{selectTable.valor.ci}}
            </v-list-item-subtitle>

            <br>
            <v-list-item-title>Empresa: {{selectTable.valor.E}} </v-list-item-title>
        </v-list-item-content>
         </v-list-item>

          
            <v-card-title>
              Hora:
            </v-card-title>
            <v-card-subtitle>
               Inicio: {{selectTable.valor.h_i}} - Final: {{selectTable.valor.h_f}}
            </v-card-subtitle>

            <v-card-title>
              Kilometraje:
            </v-card-title>
            <v-card-subtitle>
               Inicio: {{selectTable.valor.k_i}} - Final: {{selectTable.valor.k_f}}
            </v-card-subtitle>

            <v-card-title>
              Trabajo y Trayectoria:
            </v-card-title>
            <v-card-subtitle>
               Ord: {{selectTable.valor.ord}} - Sobre Tiempo: {{selectTable.valor.st}}
            </v-card-subtitle>
            <v-card-subtitle>
               Trayectoria: {{selectTable.valor.trayecto}}
            </v-card-subtitle>
          
          
          


      

       

         
         
          
        </div>

         <v-card-actions>
     <v-btn
        color="primary"
        text
         @click="show = !show"
      >
        Comentarios o Alertas
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn
        icon
        @click="show = !show"
      >
        <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </v-card-actions>

    <v-expand-transition>
      <div v-show="show" class="conedor-sitebar-hijo">
        <v-divider></v-divider>

        <div v-if="selectTable.valor.alerta != null">
             <v-card-text >
             Cambio conductor: {{selectTable.valor.alerta.description}}
            </v-card-text>
        </div>
       
       <div v-if="selectTable.valor.alerta_comentario != null">
             <v-card-text >
               Comentarios: {{selectTable.valor.alerta_comentario}}
             </v-card-text>
        </div>
        
      </div>
    </v-expand-transition>
      </div>
    </div>    
</template>

<script>

import moment from 'moment'

export default {
    
    data(){
        return {

           show:false, 
           //fecha_registro_human:moment(selectTable.valor.fecha).format("MMM Do YY")


        }
    },

    computed:{

        selectTable(){

            return this.$store.state.select_table;

        }

    },

    methods:{


        Cerrar:function(){

            this.$store.dispatch('asidebarRegistro', false);

        }

    }

}
</script>
<style>


    .contenedor-sitebar{

        position: fixed;
        right: 0;
        top:0;
        z-index: 99;
        height: 100%;
        width: 30%;
        background-color: white;
        box-shadow: 2px 5px 10px gray;
        
      

    }

    .conedor-sitebar-hijo{

      overflow-y: scroll;
      max-height: 200px;

    }


    .colorred {
      color: red;
    }



</style>